import { ArrowRight } from "lucide-react";
import { MaskedLine, FadeUp, Overline } from "../components/Reveal";
import { useEnquiry } from "../context/EnquiryContext";
import { CLIENTS } from "../data/content";

export default function Clients() {
  const { openEnquiry } = useEnquiry();

  return (
    <main data-testid="clients-page">
      <section className="pt-32 sm:pt-44 pb-14 sm:pb-20 px-5 sm:px-8 lg:px-12 border-b border-ink/15">
        <FadeUp immediate y={12}>
          <Overline className="mb-8">Our Clients</Overline>
        </FadeUp>
        <h1 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-[13vw] sm:text-8xl">
          <MaskedLine immediate delay={0.15}>Trusted By</MaskedLine>
          <MaskedLine immediate delay={0.3}>Industry.</MaskedLine>
        </h1>
        <FadeUp immediate delay={0.45} className="mt-8 max-w-xl">
          <p className="text-base sm:text-lg text-ink/65 leading-relaxed">
            A selection of the businesses that rely on Jagdamba Enterprises for their hardware
            and industrial supply requirements.
          </p>
        </FadeUp>
      </section>

      <section className="px-5 sm:px-8 lg:px-12 py-16 sm:py-24 border-b border-ink/15">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/15 border border-ink/15">
          {CLIENTS.map((client, i) => (
            <FadeUp key={client.name} delay={i * 0.04}>
              <div
                data-testid={`client-${client.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="bg-paper px-8 py-14 sm:py-20 h-full flex flex-col justify-between gap-8 hover:bg-white transition-colors"
              >
                <span className="font-mono text-[11px] tracking-[0.25em] text-ink/35">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {client.logo ? (
                  <img
                    src={client.logo}
                    alt={`${client.name} logo`}
                    className="max-h-16 sm:max-h-20 w-auto max-w-full object-contain self-start"
                    loading="lazy"
                  />
                ) : (
                  <span className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl text-ink/80">
                    {client.name}
                  </span>
                )}
              </div>
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="bg-accent text-ink px-5 sm:px-8 lg:px-12 py-16 sm:py-24">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.92] text-3xl sm:text-5xl max-w-2xl">
            Join the businesses that count on us.
          </h2>
          <button
            data-testid="clients-bottom-cta"
            onClick={() => openEnquiry("")}
            className="inline-flex items-center gap-2 bg-ink text-paper font-mono text-xs tracking-[0.2em] uppercase px-8 py-5 hover:bg-paper hover:text-ink transition-colors self-start"
          >
            Send Your Requirement <ArrowRight size={14} />
          </button>
        </div>
      </section>
    </main>
  );
}
